import React from "react";
import Typography from "@mui/material/Typography";

export const ViewTitle = ({ title, ...rest }) => {
  return (
    <Typography variant="h6" {...rest}>
      {title}
    </Typography>
  );
};

export default ViewTitle;
